// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"71591c7d","703":"6f9a563b","787":"cf210d9e"}[chunkId] + ".chunk.js";
};